import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useGame } from '@/app/providers/GameContextProvider';
import { useGlobalPopup } from '@/app/providers/GlobalPopupProvider';
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import { FlashModeSettings, CustomModeSettings } from '@/lib/types/common/GameModeAdvancedSettings';
import InputFFXIV from '../../../InputFFXIV';
import TooltipWithIconFFXIV from '@/app/components/TooltipWithIconFFXIV';

const FlashDurationSelector: React.FC = () => {
    const { t } = useTranslation();
    const { room, gameState } = useGame();
    const { showPopup } = useGlobalPopup();
    const { settings, updateSettings, isGameMaster } = useGameModeSettingsContext();

    if (!room || !gameState) return null;

    const value = (settings as FlashModeSettings | CustomModeSettings).flashDuration ?? 1000;

    const handleFlashDurationChange = (newDuration: number) => {
        if (isGameMaster) {
            updateSettings({ flashDuration: newDuration } as Partial<FlashModeSettings>);
        } else {
            showPopup({
                type: 'error',
                message: t('lobby.onlyGameMasterCan'),
            });
        }
    };

    return (
        <div className="flex gap-4 items-center">
            <div className="flex gap-3 items-center">
                <div className="text-[#EEE1C5] text-shadow-border shadow-black text-lg">
                    {t('game.config.advancedSettings.flashDuration')}
                </div>
                <InputFFXIV
                    value={value}
                    onChange={(newValue) => handleFlashDurationChange(newValue)}
                    min={100}
                    max={10000}
                    step={100}
                    className="!w-[70px]"
                />
            </div>
            <TooltipWithIconFFXIV text={t('game.config.advancedSettings.flashDurationTooltip')} />
        </div>
    );
};

export default FlashDurationSelector;
